<template>
<div class="app-header">
		<ol class="breadcrumb pull-left">
			<li class="breadcrumb-item" >NAVER Datacenter Visitor Management System</li>
			<!--<li class="breadcrumb-item active">-->
        <!--<a href="">site name</a>-->
      <!--</li>-->
		</ol>

		<!-- Include Console GNB -->
		<ul class="nav pull-right" v-if="empData.isLogin">
        <li class="nav-item">
            <div class="dropdown">
                <button class="btn btn-md line-2 dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
                    <i class="icon-my mr-5"></i>
                    <span class="text-light-blue">{{empData.empName}}</span> 님</button>
                <div class="dropdown-menu dropdown-menu-scale pull-right">
                    <a class="dropdown-item">로그아웃</a>
                </div>
            </div>
        </li>
    <!--<li class="nav-item">-->
        <!--<div class="dropdown type2 inline">-->
            <!--<a class="dropdown-toggle type2" data-toggle="dropdown">-->
                <!--<i class="icon-user-basic" style="font-size:26px"></i>-->
            <!--</a>-->
            <!--<div class="dropdown-menu dropdown-menu-scale pull-right">-->
                <!--<ul>-->
                    <!--<li>-->
                        <!--<a class="dropdown-item title">-->
                            <!--<span class="text-light-blue">{{empData.empName}}</span> 님-->
                        <!--</a>-->
                    <!--</li>-->
                <!--</ul>-->
                <!--<div class="dropdown-divider"></div>-->
                <!--<ul>-->
                    <!--<li>-->
                        <!--<ul>-->
                            <!--<li>-->
                                <!--<a class="dropdown-item" disabled>포털 바로가기</a>-->
                            <!--</li>-->
                            <!--<li>-->
                                <!--<a class="dropdown-item" disabled>이용관리</a>-->
                            <!--</li>-->
                            <!--<li>-->
                                <!--<a class="dropdown-item" disabled>계정관리</a>-->
                            <!--</li>-->
                            <!--<li>-->
                                <!--<a class="dropdown-item" disabled>나의 문의 내역</a>-->
                            <!--</li>-->
                            <!--<li>-->
                                <!--<a class="dropdown-item" @click="logout()">로그아웃</a>-->
                            <!--</li>-->
                        <!--</ul>-->
                    <!--</li>-->
                <!--</ul>-->
            <!--</div>-->
        <!--</div>-->
    <!--</li>-->
	</ul>
</div>
</template>

<script>
export default {
  data() {
    return {
      updateDate: null,
      currentEmployee: null
    };
  },
  mounted() {

    this.loadData();
  },
  computed: {
    empData() {
      var result = {empName: null};
      if(this.$store.state.login.empName) {
        result = {
            empName: this.$store.state.login.empName,
            isLogin: this.$store.state.login.isLogin
        }
      }
      return result;
    },
    userData() {
      return {
        userLevel : this.$store.state.login.userLevel,
        userIdcAuth : this.$store.state.login.userIdcAuth
      }
    }
  },
  methods: {
    init(){
      //this.loadData();
    },
    loadData(){
      //this.currentEmployee = JSON.parse(localStorage.getItem('currentEmployee') || null);
    },
    logout(){
      this.$store.dispatch('login/LOGOUT');
      this.$router.push({path: '/home'});

    },
    getCurrentEmployee(){
      var that = this;
      this.$http.get('/api/public/emp/getCurrentEmployee')
        .then((result) => {
          that.getCurrentEmployee = result.data;


        }).catch((e) =>{
          console.log(e);
      })
    },
    refresh() {

    },
  },
};
</script>

<style>
</style>
